import { Badge } from './badge/badge';
import { Button } from './button/button';
import { Checkbox } from './controls/checkbox/checkbox';
import { DatePicker } from './controls/date-picker/date-picker';
import { InputSearch } from './controls/input-search/input-search';
import { InputText } from './controls/input-text/input-text';
import { TextArea } from './controls/text-area/text-area';
import { Radio } from './controls/radio/radio';
import { Select } from './controls/select/select';
import { DateRangePicker } from './date-range-picker/date-range-picker';
import { Icon } from './icon/icon';
import { LoadAnimation } from './load-animation/load-animation';
import { Logo } from './logo/logo';
import { MainContainer } from './main-container/main-container';
import { OpenClose } from './open-close/open-close';
import { Pagination } from './pagination/pagination';
import { Spinner } from './spinner/spinner';
import { SummaryLateral } from './summary-lateral/summary-lateral';
import { Switch } from './switch/switch';
import { Table } from './table/table';
import { Tabs } from './tabs/tabs';
import { Title } from './title/title';
import { FilterSidebar } from './filter-sidebar/filter-sidebar';
import { Chart } from './chart/chart';
import { InputIAPrompt } from './controls/input-ia-prompt/input-ia-prompt';
import { InputIASwitch } from './input-ia-switch/input-ia-switch';

export {
  Badge,
  Button,
  Checkbox,
  DatePicker,
  InputSearch,
  InputText,
  TextArea,
  Radio,
  Select,
  DateRangePicker,
  Icon,
  LoadAnimation,
  Logo,
  MainContainer,
  OpenClose,
  Pagination,
  Spinner,
  SummaryLateral,
  Switch,
  Table,
  Tabs,
  Title,
  FilterSidebar,
  Chart,
  InputIAPrompt,
  InputIASwitch,
};

export const Shared = [
  Badge,
  Button,
  Checkbox,
  DatePicker,
  InputSearch,
  InputText,
  TextArea,
  Radio,
  Select,
  DateRangePicker,
  Icon,
  LoadAnimation,
  Logo,
  MainContainer,
  OpenClose,
  Pagination,
  Spinner,
  SummaryLateral,
  Switch,
  Table,
  Tabs,
  Title,
  FilterSidebar,
  Chart,
  InputIAPrompt,
  InputIASwitch,
];
